class StrokeAnalysisEventCtrl
  constructor: (@$scope) ->
    @strokeData =
      avg_shot_par3: 0
      avg_shot_par4: 0
      avg_shot_par5: 0

    @$scope.$on "myAnalysisEventUpdated.gnp.analysis", (event, myAnalysis) =>
      @strokeData = myAnalysis.my_avg

StrokeAnalysisEventCtrl.$inject = [
  '$scope'
]
module.exports = StrokeAnalysisEventCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/stroke-analysis/stroke-analysis-controller.coffee